module.exports = __webpack_public_path__ + "static/media/q5.655e19e4.png";